module.exports = __webpack_public_path__ + "img/02-04.cfe00993.png";